export interface SessionData {
    initData: string | null;
    sessionId: string;
    expiration: number;
}

export const isLicenseValid = (expiration: number): boolean => {
    return expiration > Date.now();
};
